// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFeatures } from "flagged";
import { Search, Icon, Modal } from "semantic-ui-react";
import _ from "lodash";
import { Div } from "@components/Generics.react";

// -------------------------------------
// Import Styles
// -------------------------------------
import "@styles/components.scss";
import { deckFormats } from "@schemas/deckFormats";
import ArticleRaw from "@player/articles/ArticleRaw.react";

// -------------------------------------
// Constants
// -------------------------------------
// prettier-ignore
export default function RestrictedSearchField(props) {
    const { infobase = "" } = props;
    const allArticles = useSelector((state) => state.articles);
    const allowedReaderTypes = [
        "htmldeck",
        "videck",
        "reeldeck",
        "infodeck",
        "docdeck",
    ];

    const { t } = useTranslation("common");

    const articles = _.uniq(infobase.split(",").map((a) => a.trim()))
        .map((a) => allArticles.list[a])
        .filter((a) => a && getReaderType(a.category) != null)
        .map((a) => ({ ...a, readerType: getReaderType(a.category) }));

    const { placeholder = t("search.placeholder"), exSearch = "" } = props;
    const [searchTerm, setSearchTerm] = useState(exSearch);
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [articleModalOpen, setArticleModalOpen] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    const features = useFeatures();

    useEffect(() => {
        if (exSearch && exSearch !== "undefined") {
            const formattedSearch = exSearch.replace(/_/g, " ");
            setSearchTerm(_.capitalize(formattedSearch));
        } else {
            setSearchTerm("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exSearch]);

    const handleSearch = (searchText) => {
        const lowerCaseSearchTerm = searchText.toLowerCase().replace(/_/g, " ");
        const fArticles = _.filter(articles, (article) => {
            return article.name.toLowerCase().includes(lowerCaseSearchTerm);
        }).slice(0, 7);
        setFilteredArticles(fArticles);
        setSearchTerm(searchText);
    };

    const handleResultSelect = (event, { result }) => {
        setSelectedArticle(result);
        console.log(result);

        setArticleModalOpen(true);
    };

    function getReaderType(category) {
        const thisReaderType = (
            _.find(deckFormats, {
                category: category,
            }) ||
            _.find(deckFormats, {
                readerType: category,
            })
        )?.readerType;
        if (thisReaderType && allowedReaderTypes.includes(thisReaderType))
            return thisReaderType;
        else return null;
    }

    const articleModal = (
        <Modal
            basic
            open={articleModalOpen}
            onClose={() => setArticleModalOpen(false)}
            className={`sim-infobase-modal ${selectedArticle?.readerType}`}
        >
            <Div
                danger
                large
                medpad
                clickable
                absolute
                fit-content
                className="modal-closer"
                onClick={() => setArticleModalOpen(false)}
            >
                <Icon name="close" />
            </Div>
            {selectedArticle && (
                <Div fullht autoOverflowY white>
                    <ArticleRaw article={selectedArticle} />
                </Div>
            )}
        </Modal>
    );

    return (
        <Div inline>
            {articles.length > 0 && (
                <Search
                    fluid
                    input={{
                        icon: <Icon name="search" />,
                    }}
                    className={features.darkMode ? "dark-mode" : ""}
                    placeholder={placeholder}
                    minCharacters={3}
                    value={searchTerm}
                    onSearchChange={(event, data) => handleSearch(data.value)}
                    onResultSelect={handleResultSelect}
                    results={filteredArticles || []}
                    resultRenderer={(result) => (
                        <div key={"results"}>{result.name}</div>
                    )}
                />
            )}
            {articleModal}
        </Div>
    );
}
